module.exports = __webpack_public_path__ + "static/img/headPortrait_girl.33e0df66.png";